import reduceReducers from 'reduce-reducers'

import { default as ExpenseReducer } from './Expense'
import { default as PaymentReducer } from './Payment'
import { default as ReceiptReducer } from './Receipt'
import { default as RefundReducer } from './Refund'
import { default as BenefitCardReducer } from './BenefitCard'
import { default as BuildABillReducer } from './BuildABill'
import { default as PaymentQuestionsReducer } from './PaymentQuestions'
import { default as ClinicalNotesReducer } from './ClinicalNotes'
import { default as AIFollowUpQuestionsReducer } from './AIFollowUpQuestions'
import { default as PharmacyPrescriptionFormReducer } from './PharmacyPrescriptionForm'
import { default as RecurringExpenseFormReducer } from './RecurringExpenseForm'

export * from './Expense'
export * from './Payment'
export * from './Receipt'
export * from './Refund'
export * from './BenefitCard'
export * from './BuildABill'
export * from './PaymentQuestions'
export * from './ClinicalNotes'
export * from './AIFollowUpQuestions'
export * from './PharmacyPrescriptionForm'
export * from './RecurringExpenseForm'

// Export types and initialState from separate file to avoid circular dependencies
import { types, initialState } from './types'
export { types, initialState }
export default reduceReducers(
  ExpenseReducer,
  PaymentReducer,
  ReceiptReducer,
  RefundReducer,
  BenefitCardReducer,
  BuildABillReducer,
  PaymentQuestionsReducer,
  ClinicalNotesReducer,
  AIFollowUpQuestionsReducer,
  PharmacyPrescriptionFormReducer,
  RecurringExpenseFormReducer,
  // the last arg MUST be the shared state
  initialState,
)
